/***
 * Created on 2024/3/28
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';

function VerifyMethodItem({isDisable, image, description, onClickAction}) {

    return (
        <div className={`common-block-item cursor-pointer mb-10 ${isDisable ? 'disabled' : ''}`} onClick={onClickAction}>
            <div className="common-block-item__img">
                <img src={image} alt=""/>
            </div>
            <div className="common-block-item__text">{description}</div>
        </div>
    );
}

export default VerifyMethodItem;